import { render, staticRenderFns } from "./Bread.vue?vue&type=template&id=49add454&scoped=true&"
import script from "./Bread.vue?vue&type=script&lang=ts&"
export * from "./Bread.vue?vue&type=script&lang=ts&"
import style0 from "./Bread.vue?vue&type=style&index=0&id=49add454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49add454",
  null
  
)

export default component.exports